import { render } from "./SimpleSidebar.vue?vue&type=template&id=682cd44a&scoped=true"
import script from "./SimpleSidebar.vue?vue&type=script&lang=js"
export * from "./SimpleSidebar.vue?vue&type=script&lang=js"

import "./SimpleSidebar.vue?vue&type=style&index=0&id=682cd44a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-682cd44a"],['__file',"src/components/SimpleSidebar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "682cd44a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('682cd44a', __exports__)) {
    api.reload('682cd44a', __exports__)
  }
  
  module.hot.accept("./SimpleSidebar.vue?vue&type=template&id=682cd44a&scoped=true", () => {
    api.rerender('682cd44a', render)
  })

}


export default __exports__